import { gql } from '@apollo/client';

export const sessionQuery = gql`
  query session {
    session {
      name
      email
      id
      role {
        id
        name
      }
      b2b {
        id
        name
        secretKey
      }
      permissions {
        id
        permission
      }
    }
  }
`;

export const signInMutation = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(input: { email: $email, password: $password }) {
      accessToken
    }
  }
`;

export const requestPasswordRecoverMutation = gql`
  mutation requestPasswordRecover($email: String!) {
    requestPasswordRecover(email: $email)
  }
`;

export const updatePasswordMutation = gql`
  mutation updatePassword($newPassword: String!) {
    updatePassword(newPassword: $newPassword)
  }
`;
